import { __assign } from "tslib";
import React from 'react';
import { Typography } from './Typography';
import { colors } from '../../theme';
import { FlexRow } from '../layout/FlexRow';
import { Label } from './Label';
export var ResourceDropDownItem = function (_a) {
    var resourceName = _a.resourceName, resourceType = _a.resourceType, icon = _a.icon, permissions = _a.permissions, onClick = _a.onClick, width = _a.width, style = _a.style;
    return (React.createElement("div", { style: __assign({ minWidth: '279px', width: width ? width : '279px', backgroundColor: colors.white, paddingTop: '8px', paddingBottom: '8px', paddingLeft: '12px', paddingRight: '12px', display: 'flex', justifyContent: 'space-between', boxSizing: 'border-box', cursor: 'pointer', gap: '10px' }, style), onClick: onClick },
        React.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '9px'
            } },
            React.createElement("div", { style: {
                    width: '20px',
                    minWidth: '20px',
                    maxWidth: '20px',
                    borderRadius: '4px',
                    alignSelf: 'flex-start'
                } }, icon ? icon : null),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    width: '90%'
                } },
                React.createElement(Typography, { variant: 'breadcrumbLink', color: colors.gray[90], style: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%'
                    } }, resourceName),
                React.createElement(Typography, { variant: 'breadcrumbLink', color: colors.gray[70], style: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%'
                    } }, resourceType))),
        React.createElement(FlexRow, { justifyContent: 'flex-end', alignItems: 'center', columnGap: '4px' }, permissions && permissions.length >= 1 ?
            permissions.map(function (permission, index) {
                return (React.createElement(Label, { key: index, variant: 'gray', text: permission, style: { height: '25px' } }));
            })
            :
                null)));
};
